import { AppState } from "@shared/interfaces";
import { createSelector } from "reselect";

const selectSensorDataFile = (state: AppState) => state.sensorDataFile;

export const getSensorDataFiles = () => createSelector(selectSensorDataFile, (state) => state.files);
export const getSensorDataFilesTotal = () => createSelector(selectSensorDataFile, (state) => state.filesTotal);
export const getUploadedFile = () => createSelector(selectSensorDataFile, (state) => state.uploaded_file);
export const getCurrentFile = () => createSelector(selectSensorDataFile, (state) => state.current_file);
export const getCurrentFileValues = () => createSelector(selectSensorDataFile, (state) => state.current_file_values);
export const getCurrentFileValuesFilter = () =>
  createSelector(selectSensorDataFile, (state) => state.current_file_values_filter);
export const getFilter = () => createSelector(selectSensorDataFile, (state) => state.filter);
export const getFileUploadingPercentage = () => createSelector(selectSensorDataFile, (state) => state.file_perscentage);
